(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name createPairing.service:CreatePairing
     *
     * @description
     *
     */
    angular
        .module('createPairing')
        .service('CreatePairing', CreatePairing);

    function CreatePairing(RemoteService, MessageService, EventManagerService, CommonLogicService, PopupManager, CommonMasterData, applicationConstants, StorageServices) {
        var self = this,fdpAddRemoveFlag='add';
        self.seachActions = ['flightSearch', 'trainingSearch', 'eventSearch'];
        self.searcParamStore = {};
        self.lastAddedBlock = {};
        self.airports = [];
        self.masterDate = {
            crewTypes:[],
            crewBaseList:[],
            airportList:[],
            events:[],
            airCraftTypes:[],
            languageList:[],
            trainingCategoryList:[]
        }
        self.model  = {
            version:null,
            pairingId:null,
            pairingLanguageCrew:[],
            pairingGenderReq: {},
            pairingCrewRequirement:[],
            crewReqForModifyPairing:null,
            searchAction:null,
            searchCriteria : null,
            configData:null,
            flightData:null,
            flightFilteredData:null,
            trainingFilteredData:null,
            trainingData:null,
            blockResponse:[],
            fdpValidationRequest:{
                trainingDTOs:[],
                eventDTOs:[],
                flightLegDTOs:[],
                crewReq:[],
                defaultCrewReq:[],
                base: null,
                isHeavyFlying:false,
                restInSeat:false,
                minConnTime:0,
                continueWithViolation:null,
                showEventRest:false,
                isNightFlyNightCredit:false,
                isCommandersDiscretion:false,
              isDispatchFlight:false,
                isRestRequired:false,
                isAcmiOperation:false,
                frontendRequest:true
            },
            savePairingRequest:{
                patternId:null,
                base: null,
                isHeavyFlying:false,
                minConnTime:0,
                continueWithViolation:null,
                version:null,
                pairingName:"",
                fromDate:"",
                toDate:"",
                sunday:false,
                monday:false,
                tuesday:false,
                wednesday:false,
                thursday:false,
                friday:false,
                saturday:false,
                crewReq:[],
                restInSeat:false,
                languageReq:[],
                genderReq: {},
                distributionIdentifier:"",
                ignoreDuplicates:false,
                assignedProfileIds:[],
                editingProfileIds:[],
                continueIllegal:false,
                userConfirm:false,
                ignoreExpiries:false,
                minimumRestInMin:null,
                showEventRest:false,
                isNightFlyNightCredit:false,
                relatedPatterns:[],
                isCommandersDiscretion:false,
              isDispatchFlight:false,
              acmiTypeCode: null,
            },
          blockNames:[],
          isEditPairing:false,
          patternName:"",
          airlineBase:"",
          deadHeadTravelCrewRequest:{
              patternIds:null,
              resubmit:false,
              modifyPairing:false
          },
          overrideTravelRequest:{
            patternIds:null
          }
        };

        self.LOADMODE = {
            ADD:'add',
            COPY:'copy',
            EDIT:'edit'
        };

        self.BLOCK_TYPE = {
            EVENT:'event',
            FLIGHT:'flight',
            TRAINING:'training'
        };

        self.TRAINING_COLOR_MAP = applicationConstants.TRAINING_COLOR_MAP;

        self.LANGUAGES = [];

        self.blockColorsForFlight = [];
        self.blockColorsForEvent = [];
        self.blockColorsForTraining = [];
        self.trackingColorsOthers = [];

        self.RESTONLIST = [
            {itemCode:"SEAT", itemDecs:"Seat"},
            {itemCode:"BUNK", itemDecs:"Bunk"}
        ];
        self.pageMode = self.LOADMODE.ADD;
        /**
         * Event panel search criteria
         * @returns {{selectedEvent: null, fromDate: {disabled: boolean, value: string}, toDate: {disabled: boolean, value: string}, startTime: {disabled: boolean, value: string}, endTime: {disabled: boolean, value: string}, startLocation: {disabled: boolean, value: string}, endLocation: {disabled: boolean, value: string}, aircraftType: {disabled: boolean, value: string}, airportStandBy: {disabled: boolean, value: string}, excludeFromPayment: {disabled: boolean, value: string}, outStationOFF: {disabled: boolean, value: string}, remarks: {disabled: boolean, value: string}, duration: {disabled: boolean, value: string}}}
         */
        self.searchPanelEvent = function(){
            return {
                selectedEvent:null,
                fromDate:{
                    disabled:false,
                    value:''
                },
                toDate:{
                    disabled:false,
                        value:''
                },
                startTime:{
                    disabled:false,
                        value:''
                },
                endTime:{
                    disabled:false,
                        value:''
                },
                startLocation:{
                    disabled:false,
                        value:''
                },
                endLocation:{
                    disabled:false,
                        value:''
                },
                aircraftType:{
                    disabled:true,
                        value:''
                },
                airportStandBy:{
                    disabled:true,
                        value:''
                },
                excludeFromPayment:{
                    disabled:true,
                        value:''
                },
                outStationOFF:{
                    disabled:true,
                        value:''
                },
                remarks:{
                    disabled:false,
                        value:''
                },
                duration:{
                    disabled:false,
                        value:''
                },
              eventRelevantFlightLeg:{
                    disabled:false,
                        value:null
                }
            };
        };

        /**
         * DTO definition CrewReqDTO
         */
        function CrewReqDTO(){
            this.crewTypeCode='';
            this.requiredCrew=0;
            this.version=null;
            this.id=null;
            this.augmentedCrew=0;
        };

        /**
         * LanguageRequirementView DTO
         * @constructor
         */
        function LanguageRequirementViewDTO(){
            this.langCode="";
            this.noOfCrew=0;
            this.id=null;
            this.version=null;
            this.minReqCrew = 0;
        };

        function GenderRequirementViewDTO(){
          this.noOfMaleCrew=0;
          this.noOfFemaleCrew=0;
          this.id=null;
          this.version=null;
        };

        /**
         * LanguageRequirement DTO
         * @constructor
         */
        function LanguageRequirement(){
            this.langCode = "";
            this.languageDesc = "";
            this.noOfCrew = 0;
            this.minReqCrew = 0;
        };

        /**
         * DTO definition EventDTO
         */
        function EventDTO(){
            this.slotId="";
            this.eventId=0;
            this.eventCode="";
            this.endLocation='';
            this.airCraftType='';
            this.remarks='';
            this.isAirportStandBy=false;
            this.excludeFormPayment=false;
            this.isOutStationOff=false;
            this.startLocation='';
            this.fromDateStr='';
            this.fromTimeStr='';
            this.toDateStr='';
            this.toTimeStr='';
            this.eventRelevantFlightLeg= null;
            this.flightNo= null;
        };

        /**
         * DTO definition FlightLegDTO
         */
        function FlightLegDTO(){
            this.slotId="";
            this.flightLegId=0;
            this.flightNo='';
            this.endLocation='';
            this.modelNo='';
            this.vipStatus='';
            this.startLocation='';
            this.fromDateStr='';
            this.fromTimeStr='';
            this.toDateStr='';
            this.toTimeStr='';
            this.plannedFromDateStr='';
            this.plannedFromTimeStr='';
            this.plannedEndDateStr='';
            this.plannedEndTimeStr='';
        };

        /**
         * DTO definition TrainingDTO
         */
        function TrainingDTO(){
            this.slotId='';
            this.startLocation='';
            this.fromDateStr ='';
            this.fromTimeStr='';
            this.startDateZulu = '';
            this.startTimeZulu = '';
            this.endDateZulu = '';
            this.endTimeZulu = '';
            this.toDateStr='';
            this.toTimeStr='';
            this.trainingSlotId=0;
            this.subProgramCode='';
            this.subProgramDetail='';
            this.subProgramDetailId='';
            this.trainingSlot='';
            this.trainingProgramId='';
            this.trainingLocationID='';
            this.checkInBuffer='';
            this.checkOutBuffer='';
            this.isRestRequired = false;
        };

        /**
         * Event registration for create pairings
         */
        EventManagerService.registerEventListener(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE, function(){
            updateBlockObjectInView();
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING,false);
        });

        /**
         *
         * @param action
         * @returns {*}
         */
        self.getSearchParamByAction = function (action){
            return self.searcParamStore[action];
        };

        /**
         *
         * @param action
         * @param params
         */
        self.setSearchParamToAction = function (action, params){
            self.searcParamStore[action] = params;
        };

        /**
         * get the languages for pairing
         * @returns {LanguageRequirement}
         */
        self.getLanguageForPairings = function(){
            return new LanguageRequirement();
        };

        /**
         * Search pairing
         * @param successFn
         * @param errorFn
         */
        self.searchPairingForFlight = function (successFn, errorFn) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING,true);
            self.model.searchCriteria.startPosition = 1;
            RemoteService.loadFlightForPairing(self.model.searchCriteria, false).then(
                function(response){
                    var resObj = adaptFlightsResponse(response);
                    successFn(resObj);
                },
                function(error){
                    errorFn(error.msg[0]);
                }
            );
        };


      function LanguageReqInfoDTO(){
        this.languageCode = null;
        this.languageDesc = null;
      }

      self.searchLanugages = function(successFn, errorFn){
        RemoteService.loadLanguageList().then(
          function (response) {
            var formated = [];
            angular.forEach(response.languageList, function(lang) {
              var language = new LanguageReqInfoDTO();
              language.languageCode = lang.languageCode;
              language.languageDesc = lang.languageDesc;
              formated.push(language);
            });

            successFn(formated);
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      }




        /**
         * set flight filter data
         * @param filteredData
         */
        self.setFlightFilteredData = function(filteredData){
            self.model.flightFilteredData = filteredData;
        };
        self.getColorCode = function(filteredData){
            return self.trackingColorsOthers ;
        };

        /**
         * get flight filter data
         * @returns {null}
         */
        self.getFlightFilteredData = function(){
            return self.model.flightFilteredData;
        };

        /**
         * set training filter data
         * @param filteredData
         */
        self.setTrainingFilteredData = function(filteredData){
            self.model.trainingFilteredData = filteredData;
        };

        /**
         * get training filter data
         * @returns {null}
         */
        self.getTrainingFilteredData = function(){
            return self.model.trainingFilteredData;
        };

        /**
         * set the continue illegal value
         * @param illegalFlg
         */
        self.setContinueIllegal = function(illegalFlg){
            self.model.savePairingRequest.continueIllegal = illegalFlg;
        };

        /**
         * get the continue illegal value
         * @param illegalFlg
         * @returns {boolean}
         */
        self.getContinueIllegal = function(illegalFlg){
            return self.model.savePairingRequest.continueIllegal;
        };

        /**
         * set the user confirm value
         * @param userConfirmFlg
         */
        self.setUserConfirm = function(userConfirmFlg){
            self.model.savePairingRequest.userConfirm = userConfirmFlg;
        };

        /**
         * get the user confirm value
         * @returns {boolean}
         */
        self.getUserConfirm = function(){
            return self.model.savePairingRequest.userConfirm;
        };

        /**
         * Append flight to the pairing
         * @param params
         * @param successFn
         * @param errorFn
         */
        self.appendPairingForFlight = function(params, successFn, errorFn){
            RemoteService.loadFlightForPairing(params, false).then(
                function(response){
                    var resObj = adaptFlightsResponse(response);
                    successFn(resObj);
                },
                function(error){
                    errorFn(error.msg[0]);
                }
            );
        };

      /**
       * Append flight to the pairing
       * @param params
       * @param successFn
       * @param errorFn
       */
      self.savePairingAudit = function(params, successFn, errorFn){
        RemoteService.savePairingAudit(params, false).then(
          function(response){
            successFn(response);
          },
          function(error){
            errorFn(error.msg[0]);
          }
        );
      };

        /**
         *
         * @param trainingData
         */

        self.setTrainingData = function(trainingData){
            self.model.trainingData = trainingData;
        };

        self.getDisabledFieldsByMode = function(mode){
            var fileds = [
                {
                    id:"distributionIdentifier",
                    disabledOn:['copy']
                },
                {
                    id:"day",
                    disabledOn:['edit']
                },
                {
                    id:"toDate1",
                    disabledOn:['edit']
                },
                {
                    id:"fromDate1",
                    disabledOn:['edit']
                },
                {
                    id:"minConnectionTime",
                    disabledOn:['edit','copy']
                },
                {
                    id:"crewRestOn",
                    disabledOn:['edit','copy']
                },
                {
                    id:"isHeavyFlying",
                    disabledOn:['edit','copy']
                },
                {
                    id:"baseAirPortCode",
                    disabledOn:['edit','copy']
                },
                {
                    id:"pairingName",
                    disabledOn:['copy']
                },
              {
                id:"isNightFlyNightCredit",
                disabledOn:['copy']
              }

            ], modeSet=[];
            angular.forEach(fileds, function (item, key) {
                if (item.disabledOn.indexOf(mode)>-1){
                    modeSet.push(item.id);
                }
            });
            return modeSet;
        };

        /**
         *
         * @returns {null}
         */
        self.getTrainingData = function(){
            return self.model.flightData;
        };

        /**
         * setContinueWithViolation
         */
        self.setContinueWithViolation = function(flg){
            self.model.fdpValidationRequest.continueWithViolation = flg;
        };
        /**
         * getPairingFlightData
         * @returns {null}
         */
        self.getPairingFlightData = function(){
            return self.model.flightData;
        };

        /**
         * setPairingFlightData
         * @param flightData
         */
        self.setPairingFlightData = function(flightData){
            self.model.flightData = flightData;
        };

        /**
         * get search with in list local data
         * @returns {*[]}
         */
        self.getSearchWithinList = function(){
            var listLocalSearchWithin = [
                {
                    value:1,
                    name:"day",
                    text:"DAY",
                    selected:true
                // },
                // {
                //     value:7,
                //     name:"week",
                //     text:"WEEK",
                //     selected:false
                // },
                // {
                //     value:30,
                //     name:"month",
                //     text:"MONTH",
                //     selected:false
                }
            ];
            return listLocalSearchWithin;
        };

        /**
         * get search options list local data
         * @returns {*[]}
         */
        self.getSearchOptions = function(){
            var listLocalSearchOptions = [
                {
                    value:0,
                    name:"utc",
                    text:"UTC"
                },
                {
                    value:1,
                    name:"lcl",
                    text:"LCL"
                }
            ];
            return listLocalSearchOptions;
        };

        /**
         * get the pairing ID
         * @returns {null}
         */
        self.getPairingId = function(){
            return self.model.pairingId;
        };

        /**
         * set pairing ID
         * @param pairingId
         */
        self.setPairingId = function(pairingId){
            self.model.pairingId = pairingId;
        };

        /**
         * get the pairing crew requirement
         * @returns {Array}
         */
        self.getPairingCrewRequirements = function(){
            return self.model.pairingCrewRequirement;
        };

        /**
         * set the pairing crew requirement
         * @param crewReq
         */
        self.setPairingCrewRequirements = function(crewReq){
            self.model.pairingCrewRequirement = crewReq;
        };

        /**
         * get pairing version
         * @returns {null}
         */
        self.getPairingVersion = function(){
            return self.model.version;
        };

        /**
         * set pairing version
         * @param version
         */
        self.setPairingVersion = function(version){
            self.model.version = version;
        };

        /**
         * get the pairing language crew requirement
         * @returns {Array}
         */
        self.getPairingLanguageCrew = function(){
            return self.model.pairingLanguageCrew;
        };

        /**
         * Set the pairing language crew requirement
         * @param languageCrewReq
         */
        self.setPairingLanguageCrew = function(languageCrewReq){
            self.model.pairingLanguageCrew = languageCrewReq;
        };

        /**
         * set search criteria for all flights training and events
         * @param criteria
         */
        self.setPairingSearchCriteria = function(criteria){
            if (self.seachActions[0] === self.model.searchAction){
                criteria.flightNumber = criteria.flightNumber!==null?criteria.flightNumber.toUpperCase():null;
                self.model.searchCriteria = adaptFlightSearchCriteria(criteria);
            }
            if (self.seachActions[1] === self.model.searchAction){
                self.model.searchCriteria = adaptTrainingsSearchCriteria(criteria);
            }
            if (self.seachActions[2] === self.model.searchAction){
                self.model.searchCriteria = adaptEventsSearchCriteria(criteria);
            }
        };

        /**
         * To get he search criteria
          * @returns {null}
         */
        self.getPairingSearchCriteria = function(){
            return self.model.searchCriteria;
        };

        /**
         * set search action
         * @param action
         */
        self.setSearchAction = function(action){
            self.model.searchAction = action;
        };


      self.setShowEventRest = function(showEventRest, callBackFn){
        self.model.fdpValidationRequest.showEventRest = showEventRest;
        doFDPValidation('add', callBackFn);
      };

        self.ConsiderActualTime = function(showEventRest, callBackFn){
            self.model.fdpValidationRequest.showEventRest = showEventRest;
            doFDPValidation('add', callBackFn);
        };

        self.getShowEventRest = function(){
            self.model.fdpValidationRequest.showEventRest
        };

        /**
         * Set basic data model for Set data for fdp validate
         * @param pairingModel
         */
        self.setDataForFDPValidate = function(pairingModel, callBackFn){
            self.lastAddedBlock = {};
            self.lastAddedBlock[pairingModel.blockType] = [getAdeptedObjectByType(pairingModel.blockType, pairingModel.block)];
            var temList = getListByBlockType(pairingModel.blockType);
            angular.forEach(self.lastAddedBlock[pairingModel.blockType], function(typedObj){
                temList.push(typedObj);
            });
            self.model.fdpValidationRequest.crewReq = adaptCrewRequirement(pairingModel.crewReq);
            if (pairingModel.base) {                          // If base is selected in the bottom panel
              self.model.fdpValidationRequest.base = pairingModel.base.airPortCode;
            } else if (pairingModel.block.startLocation) {    // Else take the start location of the block (Event)
              self.model.fdpValidationRequest.base = pairingModel.block.startLocation.value;
            } else {                                          // Else it should be training
              self.model.fdpValidationRequest.base = pairingModel.block.trainingStationDesc;
            }
            self.model.fdpValidationRequest.defaultCrewReq = pairingModel.defaultCrewReq || [];
            self.model.fdpValidationRequest.minConnTime= isNaN(parseInt(pairingModel.minConnTime,10))?null:parseInt(pairingModel.minConnTime,10);
            self.model.fdpValidationRequest.isHeavyFlying = pairingModel.isHeavyFlying;
            self.model.fdpValidationRequest.restInSeat = getValuesFormObject(pairingModel.restInSeat, 'itemCode').toUpperCase()==='SEAT'?"Y":"N";
            self.model.fdpValidationRequest.minimumRestInMin = self.adeptMinimumRestToMin(pairingModel.minimumRest);
            self.model.fdpValidationRequest.pairingId = self.model.pairingId;
            self.model.fdpValidationRequest.isNightFlyNightCredit = pairingModel.isNightFlyNightCredit;
            self.model.fdpValidationRequest.isCommandersDiscretion = pairingModel.isCommandersDiscretion;
            self.model.fdpValidationRequest.isDispatchFlight = pairingModel.isDispatchFlight;
            self.model.fdpValidationRequest.isRestRequired = pairingModel.isRestRequired;
            self.model.fdpValidationRequest.throwErrors = pairingModel.throwErrors;
            self.model.fdpValidationRequest.isAcmiOperation = pairingModel.isAcmiOperation;
            self.model.fdpValidationRequest.acmiTypeCode = (pairingModel.acmiTypeCode === null || typeof pairingModel.acmiTypeCode === 'undefined') ? null : pairingModel.acmiTypeCode.acmiCode;
            self.model.fdpValidationRequest.fdpExtensionFlags = pairingModel.fdpExtensionFlags || [];
            self.model.fdpValidationRequest.frontendRequest = true;
            self.setContinueWithViolation(false);
            fdpAddRemoveFlag = 'add';
            doFDPValidation('add', callBackFn);
        };

        self.validateFdpAfterAddingFlags = function(fdpFlags, callBackFunction){
            self.model.fdpValidationRequest.fdpExtensionFlags = fdpFlags;
            doFDPValidation('add', callBackFunction);
        }

        /**
         * set crew requirement for modify pairing
         * @param crewReq
         */
        self.setCrewRequirementsForModifyPairing = function(crewReq){
            self.model.crewReqForModifyPairing = crewReq;
        };

        /**
         * update the request params for saving after loading the pairing
         * @param pairingData
         */
        self.setLoadedPairingForSave = function(pairingData){
            self.setPairingVersion(pairingData.version);
            self.setPairingId(pairingData.patternId);
            setLoadedPairingLanguage(pairingData.patternLanguageList);
            self.setPairingCrewRequirements(pairingData.patternCrewList);
            self.setFDValidationByBlockList(pairingData.blockList);
        };

        /**
         * set colors for blocks in bottom panel
         */
        self.setColorToBlockData = function (blockList, successFn) {
        	angular.forEach(blockList, function(block){
        		angular.forEach(block.blockDetailList, function(blockDetail){

        			if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.FLIGHT) {
    					var modelNo = blockDetail.aircraftModel;
    					var found = _.find(self.blockColorsForFlight, {trackingCode:modelNo});
    					if(!!found){
    						blockDetail.backgroundColor = found.backgroundColor;
    						blockDetail.fontColor = found.fontColor;
    					}
        			}

        			if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.EVENT &&
        					!(blockDetail.eventCode === "RST" || blockDetail.eventCode === "LAY")) {
    					var eventCode = blockDetail.eventCode;
    					var found = _.find(self.blockColorsForEvent, {trackingCode:eventCode});
    					if(!!found){
    						blockDetail.backgroundColor = found.backgroundColor;
    						blockDetail.fontColor = found.fontColor;
    					}
        			}

        			if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.TRAINING) {
    					var trainingProgramCode = blockDetail.trainingProgramCode;
    					var found = _.find(self.blockColorsForTraining, {trackingCode:trainingProgramCode});
    					if(!!found){
    						blockDetail.backgroundColor = found.backgroundColor;
    						blockDetail.fontColor = found.fontColor;
    					}
        			}
        		});
        	});
        };

        self.resetValidationByBlockList = function(){
        	self.model.fdpValidationRequest.flightLegDTOs = [];
            self.model.fdpValidationRequest.eventDTOs = [];
            self.model.fdpValidationRequest.trainingDTOs = [];
        }

        /**
         * Update fdp validation request object after loading the pairing
         * @param blockList
         */
        self.setFDValidationByBlockList = function(blockList){
            self.model.fdpValidationRequest.flightLegDTOs = [];
            self.model.fdpValidationRequest.eventDTOs = [];
            self.model.fdpValidationRequest.trainingDTOs = [];
            self.model.blockNames = [];
            angular.forEach(blockList, function(block){
                getBlockNames(block.blockDetailList);
                angular.forEach(block.blockDetailList, function(blockDetail){
                    var tempBlockDetail = getListByBlockType(self.BLOCK_TYPE[blockDetail.blockDetailType]);

                    if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.FLIGHT){
                        var tempFlightBlock = getBlockBySlotId(tempBlockDetail, blockDetail.slotId);
                        if(tempFlightBlock===null){
                            tempFlightBlock = new FlightLegDTO();
                            tempFlightBlock.slotId=CommonLogicService.getRandomID();
                            blockDetail.slotId = tempFlightBlock.slotId;
                            tempBlockDetail.push(tempFlightBlock);
                        }
                        tempFlightBlock.flightLegId = blockDetail.flightLegId;
                        tempFlightBlock.flightNo=blockDetail.flightNo;
                        tempFlightBlock.endLocation=blockDetail.endLocation;
                        tempFlightBlock.modelNo=blockDetail.aircraftModel;
                        tempFlightBlock.vipStatus=null;
                        tempFlightBlock.startLocation=blockDetail.startLocation;
                        tempFlightBlock.fromDateStr=blockDetail.startDateStr;
                        tempFlightBlock.fromTimeStr=blockDetail.startTimeStr;
                        tempFlightBlock.toDateStr=blockDetail.endDateStr;
                        tempFlightBlock.toTimeStr=blockDetail.endTimeStr;
                        tempFlightBlock.actualFromDateStr=blockDetail.actualStartDateStr;
                        tempFlightBlock.actualFromTimeStr=blockDetail.actualStartTimeStr;
                        tempFlightBlock.actualEndDateStr=blockDetail.actualEndDateStr;
                        tempFlightBlock.actualEndTimeStr=blockDetail.actualEndTimeStr;
                        tempFlightBlock.revisedFromDateStr=blockDetail.startDateStr;
                        tempFlightBlock.revisedFromTimeStr=blockDetail.startTimeStr;
                        tempFlightBlock.revisedEndDateStr=blockDetail.endDateStr;
                        tempFlightBlock.revisedEndTimeStr=blockDetail.endTimeStr;


                        tempFlightBlock.plannedFromDateStr = blockDetail.revisedFromDateStr || blockDetail.startDateStr;
                        tempFlightBlock.plannedFromTimeStr = blockDetail.revisedFromTimeStr || blockDetail.startTimeStr;
                        tempFlightBlock.plannedEndDateStr  = blockDetail.revisedEndDateStr || blockDetail.endDateStr;
                        tempFlightBlock.plannedEndTimeStr  = blockDetail.revisedEndTimeStr || blockDetail.endTimeStr;

                    }

                    if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.EVENT &&
                        !(blockDetail.eventCode === "RST" || blockDetail.eventCode === "LAY")){
                        var tempEventBlock = getBlockBySlotId(tempBlockDetail, blockDetail.slotId);
                        if(tempEventBlock===null){
                            tempEventBlock = new EventDTO();
                            tempEventBlock.slotId=CommonLogicService.getRandomID();
                            blockDetail.slotId = tempEventBlock.slotId;
                            tempBlockDetail.push(tempEventBlock);
                        }
                        tempEventBlock.eventId=blockDetail.eventId;
                        tempEventBlock.eventCode=blockDetail.eventCode;
                        tempEventBlock.endLocation=blockDetail.endLocation;
                        tempEventBlock.airCraftType=blockDetail.aircraftModel;
                        tempEventBlock.remarks=null;
                        tempEventBlock.isAirportStandBy=blockDetail.isAirportStandBy;
                        tempEventBlock.excludeFormPayment=blockDetail.excludeFormPayment;
                        tempEventBlock.isOutStationOff=blockDetail.isOutStationOff;
                        tempEventBlock.startLocation=blockDetail.startLocation;
                        tempEventBlock.fromDateStr=blockDetail.startDateStr;
                        tempEventBlock.fromTimeStr=blockDetail.startTimeStr;
                        tempEventBlock.toDateStr=blockDetail.endDateStr;
                        tempEventBlock.toTimeStr=blockDetail.endTimeStr;
                        tempEventBlock.eventRelevantFlightLeg = blockDetail.eventRelevantFlightLeg;
                        tempEventBlock.flightNo = blockDetail.flightNo;
                    }

                    if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.TRAINING){
                        var tempTrainingBlock = getBlockBySlotId(tempBlockDetail, blockDetail.slotId);
                        if(tempTrainingBlock===null){
                            tempTrainingBlock = new TrainingDTO();
                            tempTrainingBlock.slotId=CommonLogicService.getRandomID();
                            blockDetail.slotId = tempTrainingBlock.slotId;
                            tempBlockDetail.push(tempTrainingBlock);
                        }
                        tempTrainingBlock.startLocation=blockDetail.startLocation;
                        tempTrainingBlock.fromDateStr=blockDetail.startDateStr;
                        tempTrainingBlock.fromTimeStr=blockDetail.startTimeStr;
                        tempTrainingBlock.toDateStr=blockDetail.endDateStr;
                        tempTrainingBlock.toTimeStr=blockDetail.endTimeStr;
                        tempTrainingBlock.trainingSlotId=blockDetail.trainingSlotId;
                        tempTrainingBlock.subProgramCode=blockDetail.trainingProgramCode;
                        tempTrainingBlock.subProgramDetail=blockDetail.trainingProgramDetail;
                        tempTrainingBlock.subProgramDetailId=blockDetail.trainingProgramDetailId;
                        tempTrainingBlock.trainingSlot=blockDetail.trainingSlot;
                        tempTrainingBlock.trainingProgramId=blockDetail.trainingProgramId;
                        tempTrainingBlock.trainingLocationID=blockDetail.trainingLocationID;
                        tempTrainingBlock.checkInBuffer=blockDetail.checkInBuffer;
                        tempTrainingBlock.checkOutBuffer=blockDetail.checkOutBuffer;
                        tempTrainingBlock.isRestRequired = blockDetail.isRestRequired;
                    }

                });
            })
          var patternName = "";
          angular.forEach(self.model.blockNames,function (name) {
            if(patternName ==""){
              patternName += name;
            }else {
              patternName += "/" + name;
            }
          });
          patternName += "-" + blockList[0].blockStartTimeStr;
          self.model.patternName =  patternName;
        };

        self.getPatternName = function () {
          return self.model.patternName;
        };

        function getBlockNames(blockDetailList){
          var restEventName = "RS ";
          var dhdEventName = "DHD";
          var sbEventName = "SB";
          var isPreviousFlight =  false;
          var lastFlightOrigin = "";
          var lastFlightDestination = "";
          angular.forEach(blockDetailList, function(blockDetail){
            if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.EVENT){
              if(blockDetail.eventCode == 'RST'){
                self.model.blockNames.push(restEventName);
              }else if(blockDetail.eventCode == 'SBY') {
                self.model.blockNames.push(sbEventName);
              }else {
                self.model.blockNames.push(blockDetail.eventCode);
              }
              isPreviousFlight =  false;
            }else if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.TRAINING){
              self.model.blockNames.push(blockDetail.trainingSlot);
              isPreviousFlight =  false;
            }else if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.FLIGHT){
              var blockName = "";
              if(isPreviousFlight && lastFlightOrigin == self.model.airlineBase.baseAirportCode && lastFlightDestination == blockDetail.startLocation && lastFlightOrigin == blockDetail.endLocation){
                blockName = lastFlightDestination;
                self.model.blockNames.pop();
                isPreviousFlight =  false;
              }else{
                blockName = blockDetail.startLocation + "-" + blockDetail.endLocation;
              }
              self.model.blockNames.push(blockName);

              isPreviousFlight =  true;
              lastFlightOrigin = blockDetail.startLocation;
              lastFlightDestination = blockDetail.endLocation;
            }
          });

        }

        /**
         * uses common logic service to get the hour by minutes
         * @param min
         * @returns {*}
         */
        self.getDutyPeriodByMinutes = function(min){
            return CommonLogicService.getHoursByMinutes(min);
        };

        /**
         * Saving pairing
         * @param pairingModel
         */
        self.saveDataForPairing = function(pairingModel){
            //Extend the fdpValidationRequest as in the back end
            self.model.savePairingRequest.patternId = self.getPairingId();
            self.model.savePairingRequest.version = self.getPairingVersion();
            self.model.savePairingRequest.assignedProfileIds = [];
            self.model.savePairingRequest.editingProfileIds = [];
            self.model.savePairingRequest.trainingDTOs = self.model.fdpValidationRequest.trainingDTOs;
            self.model.savePairingRequest.eventDTOs = self.model.fdpValidationRequest.eventDTOs;
            self.model.savePairingRequest.flightLegDTOs = self.model.fdpValidationRequest.flightLegDTOs;
            self.model.savePairingRequest.crewReq = adaptCrewRequirementSaveDTO(pairingModel.crewReq, pairingModel.crewMaleReq, pairingModel.crewFemaleReq, pairingModel.crewAugmentedReq);
            self.model.savePairingRequest.pairingName = pairingModel.pairingName;
            self.model.savePairingRequest.fromDate = pairingModel.fromDate;
            self.model.savePairingRequest.toDate = pairingModel.toDate;
            self.model.savePairingRequest.fdpExtensionFlags = pairingModel.fdpExtensionFlags || [];
            self.model.savePairingRequest.remarks = pairingModel.remarks || null;
            self.model.savePairingRequest.remarksComment = pairingModel.remarksComment || null;

          var di;

          if(pairingModel.distributionIdentifier==''){
            di = null;

          }else{
            var identifierArray = [];
            angular.forEach(pairingModel.distributionIdentifier ,function(identifier){

              identifierArray.push(identifier.valueFieldName);
            });

            di = identifierArray.toString();
          }
          self.model.savePairingRequest.distributionIdentifier = di;

            for(var i = 0;i<pairingModel.displayWeekdays.length-1;i++){
                var day = pairingModel.displayWeekdays[i+1];
                self.model.savePairingRequest[day.value] = day.selected;
            }
            self.model.isMandatory = pairingModel.isMandatory;
            self.model.savePairingRequest.languageReq = adeptLanguageReq(pairingModel.languageReq);
            self.model.savePairingRequest.genderReq = adeptGenderReq(pairingModel.genderReq);
            self.model.savePairingRequest.base = pairingModel.base.airPortCode;
            self.model.savePairingRequest.minConnTime= isNaN(parseInt(pairingModel.minConnTime,10))?null:parseInt(pairingModel.minConnTime,10);
            self.model.savePairingRequest.isHeavyFlying = pairingModel.isHeavyFlying;
            self.model.savePairingRequest.isNightFlyNightCredit = pairingModel.isNightFlyNightCredit;
            self.model.savePairingRequest.isCommandersDiscretion = pairingModel.isCommandersDiscretion;
            self.model.savePairingRequest.isDispatchFlight = pairingModel.isDispatchFlight;
            self.model.savePairingRequest.isAcmiOperation = pairingModel.isAcmiOperation;
            if (pairingModel.acmiTypeCode === null || typeof pairingModel.acmiTypeCode === 'undefined') {
              self.model.savePairingRequest.acmiTypeCode = null;
            }
            else {
              self.model.savePairingRequest.acmiTypeCode = pairingModel.acmiTypeCode.acmiCode;
            }
            self.model.savePairingRequest.restInSeat = getValuesFormObject(pairingModel.restInSeat, 'itemCode');
            self.model.savePairingRequest.assignedProfileIds = getAssignedPofileIds();
            self.model.savePairingRequest.editingProfileIds = getEditingProfileIds();
            if(self.pageMode === self.LOADMODE.EDIT || self.pageMode === self.LOADMODE.COPY){
                self.model.savePairingRequest.continueWithViolation = true;
            }
            else {
              self.model.savePairingRequest.continueWithViolation = self.model.fdpValidationRequest.continueWithViolation;
            }
          if(self.pageMode === self.LOADMODE.COPY) {
              self.model.savePairingRequest.copyPattern = true;
            }
            self.model.savePairingRequest.minimumRestInMin = self.adeptMinimumRestToMin(pairingModel.minimumRest);
            self.model.savePairingRequest.showEventRest = self.model.fdpValidationRequest.showEventRest;
            self.model.isEditPairing = pairingModel.isEditPairing;
            self.model.savePairingRequest.relatedPatternInfoList = pairingModel.selectedRelatedPatterns;
            if(self.model.isEditPairing && self.model.savePairingRequest.isAcmiOperation) {
              isNonACMICrewAvailableInPatternValidation(self.model.savePairingRequest.patternId,self.model.savePairingRequest.fromDate);
            } else {
              doPairingSave();
            }
        };

        /**
         * Remove block action
         * @param block
         */
        self.removeBlocksFromList = function(configs, block, validate, callBackFn){
            fdpAddRemoveFlag = 'remove';
            var deleteItems = block;
            self.model.fdpValidationRequest.crewReq = adaptCrewRequirement(configs.crewReq);
            self.model.fdpValidationRequest.defaultCrewReq =configs.defaultCrewReq || [];

            if (configs.base) {   // If base is selected in the bottom panel
              self.model.fdpValidationRequest.base = configs.base.airPortCode;
            } else {              // Else take the start location of the first block
              self.model.fdpValidationRequest.base = block.startLocation;
            }
            self.model.fdpValidationRequest.minConnTime= isNaN(parseInt(configs.minConnTime,10))?null:parseInt(configs.minConnTime,10);
            self.model.fdpValidationRequest.isHeavyFlying = configs.isHeavyFlying;
            self.model.fdpValidationRequest.restInSeat= getValuesFormObject(configs.restInSeat, 'itemCode').toUpperCase()==='SEAT'?"Y":"N";
            self.model.fdpValidationRequest.isCommandersDiscretion = configs.isCommandersDiscretion;
            self.model.fdpValidationRequest.isDispatchFlight = configs.isDispatchFlight;
            self.model.fdpValidationRequest.isAcmiOperation = configs.isAcmiOperation;
            self.model.fdpValidationRequest.fdpExtensionFlags = configs.fdpExtensionFlags;

            var blockDetailsDelete = false;
            if (block.hasOwnProperty("slotId")){
                deleteItems = [block];
                blockDetailsDelete = true;
            }
            self.lastAddedBlock = {};
            angular.forEach(deleteItems, function(dBlock){
                for(var i=0;i<self.model.fdpValidationRequest.flightLegDTOs.length;i++){
                    var flBlock = self.model.fdpValidationRequest.flightLegDTOs[i];
                    var fBlocksArray = self.lastAddedBlock[self.BLOCK_TYPE.FLIGHT] || [];
                    if(dBlock.slotId===flBlock.slotId){
                        fBlocksArray.push(flBlock);
                        self.model.fdpValidationRequest.flightLegDTOs.splice(i, 1);
                        break;
                    }
                }
                for(var i=0;i<self.model.fdpValidationRequest.eventDTOs.length;i++){
                    var evBlock = self.model.fdpValidationRequest.eventDTOs[i];
                    var eBlocksArray = self.lastAddedBlock[self.BLOCK_TYPE.EVENT] || [];
                    if(dBlock.slotId===evBlock.slotId){
                        if((evBlock.eventCode==="LAY" || evBlock.eventCode==="RST") &&
                            blockDetailsDelete){
                            //self.setShowEventRest(true);
                        }else{
                            eBlocksArray.push(evBlock);
                            self.model.fdpValidationRequest.eventDTOs.splice(i, 1);
                        }
                        break;
                    }
                }
                for(var i=0;i<self.model.fdpValidationRequest.trainingDTOs.length;i++){
                    var trBlock = self.model.fdpValidationRequest.trainingDTOs[i];
                    var tBlocksArray = self.lastAddedBlock[self.BLOCK_TYPE.TRAINING] || [];
                    if(dBlock.slotId===trBlock.slotId){
                        tBlocksArray.push(trBlock);
                        self.model.fdpValidationRequest.trainingDTOs.splice(i, 1);
                        break;
                    }
                }
            });
            if (validate){
                doFDPValidation('remove', callBackFn);
            }

        };

        /**
         * get languages form airports
         */
        self.getLanguagesForAirPorts = function(langugeList){
            self.airports = [];
            self.modelNos = [];
            var flOBJList = self.model.fdpValidationRequest.flightLegDTOs;
            angular.forEach(flOBJList, function(blockDetails){
                if (self.airports.indexOf(blockDetails.startLocation) === -1){
                    self.airports.push(blockDetails.startLocation);
                }
                if (self.airports.indexOf(blockDetails.endLocation) === -1){
                    self.airports.push(blockDetails.endLocation);
                }
                if(self.modelNos.indexOf(blockDetails.modelNo) === -1){
                  self.modelNos.push(blockDetails.modelNo);
                }

            });

            if (self.airports.length!==0) {
                RemoteService.loadLanguageByAirports({airports:self.airports, modelNo:self.modelNos }).then(
                    function (response) {
                        if (response.success){
                            self.LANGUAGES = response.languageRequirementViewDTOs;

                            if(angular.equals(response.isCrewComplimentsExist,"Y")){

                              EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.PAIRING_COMPLIMENTS, response.pairingComplimentsDTOList);
                            }else{
                              EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.UPDATE_LANGUAGE_LIST, self.LANGUAGES);
                              self.setPairingLanguageCrew(self.LANGUAGES);
                            }
                        }
                    },
                    function (error) {
                        MessageService.warning(error.msg[0]);
                    }
                );
            }
        };

        /**
         * Compare with the Crew requirement with master crew requirements
         * @param crewRequirement
         * @param masterCrewType
         * @returns {*}
         */
        self.checkMasterCrewTypeInCrewRequirement = function(crewRequirement, masterCrewType){
            return checkMasterCrewTypeInCrewRequirements(crewRequirement, masterCrewType);
        };


        /**
         * service init
         */
        self.initService = function(){
            resetServiceModel();
        };

        /**
         * loading pairing by
         * @param pairingId
         * @param mode
         * @param successFn
         * @param errorFn
         */
        self.loadPairingByID = function(pairingId, mode, successFn, errorFn){
            self.pageMode = mode===self.LOADMODE.COPY? self.LOADMODE.COPY : self.LOADMODE.EDIT;
            RemoteService.getPatternById(pairingId).then(
                function (response) {
                    successFn(adaptPairing(response));
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.setPatternAsPairing = function (pairingModel) {
            var crewReq = {}, langReq={};
            angular.forEach(pairingModel.patternCrewList, function (crewRew, key) {
                crewReq[crewRew.crewTypeCode] = crewRew.assignedCrew;
            });
            angular.forEach(pairingModel.patternLanguageList, function (langRew, key) {
                langReq[langRew.languageCode] = langRew.assignedCrew;
                langReq[langRew.languageCode] = langRew.requiredCrew;
            });
            pairingModel.crewReq = crewReq;
            pairingModel.languageReq = langReq;
            pairingModel.pairingName = pairingModel.patternName;
            pairingModel.fromDate = pairingModel.fromDate;
            pairingModel.toDate = pairingModel.toDate;
            pairingModel.base = {airPortCode:pairingModel.base};
            pairingModel.minConnTime=pairingModel.minConnTime;
            pairingModel.isHeavyFlying = pairingModel.heavyFlying==='Y'?true:false;
            pairingModel.isNightFlyNightCredit = pairingModel.isNightFlyNightCredit==='Y'?true:false;
            pairingModel.restInSeat = {itemCode: pairingModel.restTakenIn};
            pairingModel.continueWithViolation = true;

        };

        self.getCrewRequirementFormPairing = function(crewReqOfPairing){
            var getAssignedCrewByType = function (cType) {
                for (var i=0;i<self.model.crewReqForModifyPairing.length;i++){
                    var tmpCrewReq = self.model.crewReqForModifyPairing[i];
                    var countAdded = 0;
                  if(tmpCrewReq.crewType===cType){
                       /* angular.forEach(tmpCrewReq.assignedName, function(assignCrew, key){
                      if(assignCrew.setInPattern){
                        countAdded++;
                      }
                        });*/
                        countAdded = tmpCrewReq.requiredCrew;
                    break;
                  }

                }
                return countAdded;
            };
            angular.forEach(crewReqOfPairing, function(creRew, key){
              creRew.assignedCrew = calculateRequiredCrewCount(creRew);
            });
            return crewReqOfPairing;
        };

        function calculateRequiredCrewCount(crewReq){
          let unselectedCount = getUnselectedCrewByType(crewReq.crewTypeCode);
          if(crewReq.assignedCrew <= crewReq.requiredCrew){
            return crewReq.requiredCrew - unselectedCount;
          }

          return crewReq.assignedCrew - unselectedCount;
        }

        function getUnselectedCrewByType(crewType){
          let unselectedCount = 0;
          const crewReqs = StorageServices.getTabData('createPairing').editPairingParams.crewRequirements;

          try{
            const crewListItem = crewReqs.find(function(req){ if(req.crewType === crewType) return req;});

            crewListItem.assignedName.forEach(function(crew){
              if(!crew.setInPattern){
                unselectedCount++;
              }
            });

            return unselectedCount;
          }catch (e) {
            return 0;
          }
        }

        self.getFDPValidationResponse = function () {
            return self.model.blockResponse;
        };

        self.getBlockRelateMonthByIndex = function(index, flag, blockList){
            var selected = moment().format('DD/MM/YYYY');
            if(blockList.length>0){
                var ind = (index.toUpperCase() === 'START') ? 0 : (blockList.length - 1);
                selected = blockList[ind][flag];
            }
            return selected;
        };


        self.getSearchParam = function(requestObj) {
        	return adaptFlightSearchCriteria(requestObj);
        };

        self.getListByBlockTypeFlight = function () {
          return getListByBlockType(self.BLOCK_TYPE.FLIGHT);

        }
        /**
         * Adapting the pairing response
         * @param response
         * @returns {*}
         */
        function adaptPairing(response){
            response.pattern.relatedPatterns = response.relatedPatternInfoList;
            var adapted = response.pattern;
            return adapted;
        };

        /**
         * get the assigned crew profile ids
         * @returns {Array}
         */
        function getAssignedPofileIds(){
            var assignedProfileIds = [];
            if (self.model.crewReqForModifyPairing!==null){
                angular.forEach(self.model.crewReqForModifyPairing, function(crewReqType){
                    angular.forEach(crewReqType.assignedName, function(crewReq){
                        assignedProfileIds.push(crewReq.crewProfileId);
                    });
                });
            }
            return assignedProfileIds;
        }

        /**
         * Get the editing crew profile IDs
         * @returns {Array}
         */
        function getEditingProfileIds(){
            var editingProfileIds = [];
            if (self.model.crewReqForModifyPairing!==null){
                angular.forEach(self.model.crewReqForModifyPairing, function(crewReqType){
                    angular.forEach(crewReqType.assignedName, function(crewReq){
                        if(crewReq.setInPattern && crewReq.crewHub == null){
                          //crewReq.crewHub  is not null means he is a other hub crew
                              editingProfileIds.push(crewReq.crewProfileId);
                        }
                    });
                });
            }
            return editingProfileIds;
        }

        /**
         * Do the fdp validate
         * Call to the remote service
         * With the "self.model.fdpValidationRequest"
         */
        function doFDPValidation(flag, callBackFn){
            if (self.model.fdpValidationRequest.flightLegDTOs.length !== 0 ||
                self.model.fdpValidationRequest.trainingDTOs.length!== 0 ||
                self.model.fdpValidationRequest.eventDTOs.length!== 0){
                RemoteService.remoteFDPValidation(self.model.fdpValidationRequest).then(
                    function(response){
                    	 if (response.success){
                             if (response.hasOwnProperty("blockDTO")) {
                                 self.model.blockResponse = response;
                                 self.setFDValidationByBlockList(self.model.blockResponse.blockDTO);
                             }
                             if (response.messages!==null && response.messages.length!=0){
                                 MessageService.success(response.messages[0]);
                             }
                        	 self.setColorToBlockData(self.model.blockResponse.blockDTO);
                      		 callBackFn(self.model.blockResponse);
                             EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
                         }else{
                            if (response.warnings!=null && response.warnings.length!=0){

                                response.warnings=response.warnings.filter(function (item, pos) {
                                  return response.warnings.indexOf(item) == pos;
                                })

                                var modalObj = {};
                                modalObj.title="Warning";
                                modalObj.messages = response.warnings;
                                PopupManager.openModal('CONFIRM_DIALOG', modalObj, handelViolationAccept);
                            }else{
                                MessageService.warning('FDP Validation error');
                              //changed the base
                              EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.FDP_FAILED_CHANGE_BASE);
                            }
                        }
                    },
                    function(error){
                        deleteObjectFromList(flag);
                        MessageService.warning(error.msg[0]);
                      //changed the base
                      EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.FDP_FAILED_CHANGE_BASE);
                    }
                );
            }else{
                var response = {};
                response.blockDTO = [];
                callBackFn(response);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.VIEWPORT_DATA_CHANGE);
            }

            /**
             * Function to handel the block violation of the pairing on popup
             * @param pass
             */
            function handelViolationAccept(pass){
                if (pass==='YES'){
                    self.setContinueWithViolation(true);
                    doFDPValidation(fdpAddRemoveFlag, callBackFn);
                }else{
                    self.setContinueWithViolation(false);
                    deleteObjectFromList(fdpAddRemoveFlag);
                }
            }

        }

        /**
         * Saving pairing local function
         */
        function doPairingSave(){
            RemoteService.savePairing(self.model.savePairingRequest).then(
                function(response){
                    if (response.success){
                        if((response.missingTrainingDTOs!==null && response.missingTrainingDTOs.length!==0) ||
                            (response.missingFlightsDTOs!==null && response.missingFlightsDTOs.length!==0)){
                            removeUsedFlights(self.model.savePairingRequest.flightLegDTOs);
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.FLIGHT_DATA_CHANGE);
                            var missingListObj = {};
                            missingListObj.flightList = response.missingFlightsDTOs;
                            missingListObj.trainingList = response.missingTrainingDTOs;
                            PopupManager.openModal('MISSING_ITEMS_CREATE_PAIRING', missingListObj, handelMissingItems);
                        }else if (response.illegalCrewMap!==null){
                            removeUsedFlights(self.model.savePairingRequest.flightLegDTOs);
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.FLIGHT_DATA_CHANGE);
                            var illegalCrewMap = {};
                            illegalCrewMap.crewMap = response.illegalCrewMap;
                            PopupManager.openModal('ILLEGAL_CREW_MAP', illegalCrewMap, handelIllegalCrewMap);
                        }else{
                            removeUsedFlights(self.model.savePairingRequest.flightLegDTOs);
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.FLIGHT_DATA_CHANGE);
                            if(!self.model.isEditPairing) {
                              resetServiceModel();
                              EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.CREATE_PAIRING_SUCCESS);
                            }

                            if(self.model.isEditPairing){
                              if(response.patternBulkUpdateResponses!=null) {
                                if(response.patternBulkUpdateResponses.length > 1) {
                                  openShowBulkResponsePopUp(response.patternBulkUpdateResponses);
                                }else{
                                  EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.EDIT_PAIRING_SUCCESS);
                                }

                              }

                            }

                            MessageService.success(MessageService.MESSAGES.CREATE_PAIRING.CREATED_PAIRING_SUCCESS);


                        }

                      if(response.deadHeadsExist && !self.model.savePairingRequest.continueIllegal) {
                        self.model.deadHeadTravelCrewRequest.patternIds = response.patternIds;
                        self.model.deadHeadTravelCrewRequest.modifyPairing = self.model.isEditPairing;
                        sendDeadHeadTravelRequest(self.model.deadHeadTravelCrewRequest);
                      }

                    }else{
                        if((response.missingTrainingDTOs!==null && response.missingTrainingDTOs.length!==0) ||
                            (response.missingFlightsDTOs!==null && response.missingFlightsDTOs.length!==0)){
                            var missingListObj = {};
                            missingListObj.flightList = response.missingFlightsDTOs;
                            missingListObj.trainingList = response.missingTrainingDTOs;
                            PopupManager.openModal('MISSING_ITEMS_CREATE_PAIRING', missingListObj, handelMissingItems);
                        }else{
                            MessageService.warning('Saving failed');
                        }

                    }
                },
                function(error){
                    MessageService.warning(error.msg[0]);
                }
            );
        }
      function removeUsedFlights(flightLegDTOs){
        angular.forEach(flightLegDTOs, function(flightData){
          var theIndex = -1;
          angular.forEach(self.model.flightData, function(flightDataItem, index) {
            if (flightDataItem.flightLegId === flightData.flightLegId) {
              theIndex = index;
            }
          });
          if (theIndex > -1) {
            self.model.flightData.splice(theIndex, 1);
          }
        });
      }

      function isNonACMICrewAvailableInPatternValidation(patternId,startDate){
        //var sDate = new Date(startDate.split('/')[2],startDate.split('/')[1],startDate.split('/')[0]);
        var sDate = startDate.replaceAll('/','-');
        RemoteService.isNonACMICrewAvailableInPattern(patternId,sDate).then(
          function(response){
            if (response.success){

              var param = {
                title: 'Warning',
                messages: ["Crew who are not ACMI eligible are assigned to this pairing. Are you sure you want to continue?"]
              };

              PopupManager.openModal('CONFIRM_DIALOG', param, handelNonACMICrewAvailableInPatternValidation);

            } else {
              doPairingSave();
            }
          },
          function(error){
            MessageService.warning(error.msg[0]);
          }
        );
      }

      function handelNonACMICrewAvailableInPatternValidation(pass){
        if (pass==='YES'){
          doPairingSave();
        }
      }

      function openShowBulkResponsePopUp(bulkResponse){
        var modalParam = {
          bulkResponse: bulkResponse
        };
        PopupManager.openModal('BULK_PATTERN_UPDATE_RESPONSE_DETAILS', modalParam, closedSummaryPopUp);
      }

      function closedSummaryPopUp() {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.EDIT_PAIRING_SUCCESS);
      }

        function sendDeadHeadTravelRequest(param) {

          RemoteService.sendDeadHeadTravelRequest(param).then(
            function(response){
              if(response.success){
                var travelResponse ={};
                travelResponse.travelResponse = response.bookingResponseDTOList;

                if(response.bookingResponseDTOList.length>0){
                  PopupManager.openModal('DEADHEAD_TRAVEL_REQUEST',travelResponse, handelMissingItems);
                }

              }

            },
            function(error){
              MessageService.warning(error.msg[0]);
            }
          );
        }


      self.sendDeadHeadResubmitRequest = function (param,successFn, errorFn) {
        self.model.deadHeadTravelCrewRequest.patternIds = param;
        self.model.deadHeadTravelCrewRequest.resubmit = true;
        RemoteService.sendDeadHeadTravelRequest(self.model.deadHeadTravelCrewRequest).then(
          function(response){
            if(response.success){
              var travelResponse ={};
              travelResponse.travelResponse = response.bookingResponseDTOList;
              PopupManager.openModal('DEADHEAD_TRAVEL_REQUEST',travelResponse, handelMissingItems);

            }

          },
          function(error){
            MessageService.warning(error.msg[0]);
          }
        );
      };

      self.overrideTravelRequest = function (param,successFn, errorFn) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING,true);
        self.model.overrideTravelRequest.patternIds = param;
        RemoteService.sendOverrideTravelRequest(self.model.overrideTravelRequest).then(
          function(response){
            if(response.success){
              MessageService.success(MessageService.MESSAGES.CREATE_PAIRING.TRAVEL_REQUEST_OVERRIDDEN_SUCCESS);
            }

          },
          function(error){
            MessageService.warning(error.msg[0]);
          }
        );
      };

        /**
         * Function to handel the Illegal crew mappings of the pairing on popup
         * @param pass
         */
        function handelIllegalCrewMap(pass){
            if (pass==='YES'){
                self.setContinueIllegal(true);
                self.setUserConfirm(true);
                doPairingSave();
            }

        }

        /**
         * Function to handel missing blocks of pairing on popup
         * @param pass
         */
        function handelMissingItems(pass){
            if (pass==='YES'){

            }
          resetServiceModel();
          EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.CREATE_PAIRING_SUCCESS);

        }

        /**
         * To reset the pairing service main model
         */
        function resetServiceModel(){
            self.lastAddedBlock = {};
            self.model.blockResponse = [];
            self.model.fdpValidationRequest = {
                trainingDTOs:[],
                eventDTOs:[],
                flightLegDTOs:[],
                crewReq:[],
                defaultCrewReq:[],
                base: null,
                isHeavyFlying:false,
                isNightFlyNightCredit : false,
                isCommandersDiscretion :false,
              isDispatchFlight : false,
                restInSeat:false,
                minConnTime:0,
                continueWithViolation:null,
                showEventRest:false,
                isAcmiOperation: false
            };
            self.model.savePairingRequest = {
                    patternId:null,
                    base: null,
                    isHeavyFlying:false,
                    minConnTime:0,
                    continueWithViolation:null,
                    version:null,
                    pairingName:"",
                    fromDate:"",
                    toDate:"",
                    sunday:false,
                    monday:false,
                    tuesday:false,
                    wednesday:false,
                    thursday:false,
                    friday:false,
                    saturday:false,
                    crewReq:[],
                    restInSeat:false,
                    languageReq:[],
                    genderReq: {},
                    distributionIdentifier:"",
                    ignoreDuplicates:false,
                    assignedProfileIds:[],
                    editingProfileIds:[],
                    continueIllegal:false,
                    userConfirm:false,
                    ignoreExpiries:false,
                    minimumRestInMin:0,
                    isNightFlyNightCredit : false,
                    isCommandersDiscretion :false,
              isDispatchFlight :false,
              isAcmiOperation : false,
              acmiTypeCode : null,
            };
        }

        /**
         * Updater of the object
         */
        function updateBlockObjectInView(){

            angular.forEach(self.seachActions, function(searchType, i){
                var selectedListVIewData=null, selectedList =null;
                if (searchType === self.seachActions[0]){
                    selectedList = getListByBlockType(self.BLOCK_TYPE.FLIGHT);
                    selectedListVIewData = self.getFlightFilteredData();

                    //set false for all items
                    for (var acModel in selectedListVIewData) {
                        _.each(selectedListVIewData[acModel], function (obj) {
                            obj.usedInCurrentPattern = false;
                            obj.backGround = "1976D2";
                        });
                    }
                    for(var i=0;i<selectedList.length;i++){
                        var slBlock = selectedList[i], found;
                        for (var acModel in selectedListVIewData){
                            var temp = selectedListVIewData[acModel];
                            found = _.find(temp, function(obj){
                                return slBlock.flightLegId ===  obj.flightLegId;
                            });
                            if(found){
                                break;
                            }
                        }
                        if(found!==undefined){
                            found.usedInCurrentPattern = true;
                            found.backGround = "19b03d";
                        }
                    }
                }

                if (searchType === self.seachActions[1]){
                    selectedList = getListByBlockType(self.BLOCK_TYPE.TRAINING);
                    selectedListVIewData = self.getTrainingFilteredData();

                    //set false for all items
                    var catColorMap = self.TRAINING_COLOR_MAP;
                    for (var trModel in selectedListVIewData) {
                        _.each(selectedListVIewData[trModel]['catItems'], function (obj) {
                            obj.usedInCurrentPattern = false;
                            obj.bgColor = catColorMap[obj.trainingProCategory];
                        });
                    }
                    for(var i=0;i<selectedList.length;i++){
                        var slBlock = selectedList[i], found;
                        for (var trModel in selectedListVIewData) {
                            found = _.find(selectedListVIewData[trModel]['catItems'], function(obj){
                                return slBlock.trainingSlotId ===  obj.trainingSlotId;
                            });
                            if(found){
                                break;
                            }
                        }
                        if(found!==undefined){
                            found.usedInCurrentPattern = true;
                            found.bgColor = "#15b66d";
                        }
                    }
                }
            });
        }

        /**
         * Get list of fdpValidationRequest by the block type
         * @param blockType
         * @returns {Array}
         */
        function getListByBlockType(blockType){
            var assignList = [];
            if (self.BLOCK_TYPE.EVENT == blockType){
                assignList = self.model.fdpValidationRequest.eventDTOs;
            }
            if (self.BLOCK_TYPE.FLIGHT == blockType){
                assignList = self.model.fdpValidationRequest.flightLegDTOs;
            }
            if (self.BLOCK_TYPE.TRAINING == blockType){
                assignList = self.model.fdpValidationRequest.trainingDTOs;
            }
            return assignList;
        }

        /**
         * Get the block by the list and slot ID
         * @param list
         * @param slotId
         * @returns {*}
         */
        function getBlockBySlotId(list, slotId){
            var selectedBlock = null;
            if(slotId!==null){
                for(var i=0;i<list.length;i++){
                    if(list[i].slotId === slotId){
                        selectedBlock = list[i];
                    }
                }
            }
            return selectedBlock;
        }

        /**
         * Adept object by the block type
         * @param blockType
         * @param block
         * @returns {*}
         */
        function getAdeptedObjectByType(blockType, block){
            var adaptedObj = null;
            if (self.BLOCK_TYPE.EVENT == blockType){
                adaptedObj = adaptEvents(block);
            }
            if (self.BLOCK_TYPE.FLIGHT == blockType){
                adaptedObj = adaptFlightLegs(block);
            }
            if (self.BLOCK_TYPE.TRAINING == blockType){
                adaptedObj = adaptTrainings(block);
            }
            return adaptedObj;
        }

        /**
         * Delete block object from list
         */
        function deleteObjectFromList(flag){
            for (var key in self.lastAddedBlock){
                var blockType = '', blockArray= [], temList = [];
                blockType = key;
                blockArray = self.lastAddedBlock[key];
                temList = getListByBlockType(blockType);
                if (flag==='add'){
                    angular.forEach(blockArray, function(block){
                        var theIndex = _.findIndex(temList, block);
                        if (theIndex > -1) {
                            temList.splice(theIndex, 1);
                        }
                    });
                }else{
                    angular.forEach(blockArray, function(block){
                        temList.push(block);
                    });
                }

            }

        }

        /**
         * Adapt Flight Search Criteria
         * @param requestObj
         * @returns {{}}
         */
        function adaptFlightSearchCriteria(requestObj){
            var flightsRQ = {};
            flightsRQ.acModels = [];
            flightsRQ.carriers = [];
            flightsRQ.originList = [];
            flightsRQ.crewTypes = [];

            if(requestObj.acModels.length > 0) {
            	angular.forEach(requestObj.acModels, function (acModel) {
            		flightsRQ.acModels.push(acModel.airCraftType);
            	})
            }

			try{
				 if(requestObj.carriers.length > 0) {
	            	angular.forEach(requestObj.carriers, function (carrier) {
	            		flightsRQ.carriers.push(carrier.code);
	            	})
	            }
			}catch(e){
				console.log("aircraft not available");
			}


			if(requestObj.originList.length > 0) {
				angular.forEach(requestObj.originList, function (origins) {
            		flightsRQ.originList.push(origins.airPortCode);
            	})
            }

            if(requestObj.crewTypeCodes.length > 0) {
              angular.forEach(requestObj.crewTypeCodes, function (crewType) {
                flightsRQ.crewTypes.push(crewType.crewTypeCode);
              })
            }

            flightsRQ.flightNumber = requestObj.flightNumber;
            flightsRQ.toDate = null;
            flightsRQ.fromDate = requestObj.fromDate;
            flightsRQ.noOfDays = requestObj.noOfDays.days - 1;
            flightsRQ.startPosition = requestObj.startPosition;
            flightsRQ.pageSize = requestObj.pageSize;
            flightsRQ.nonAssignedFlights = requestObj.nonAssignedFlights;
            flightsRQ.partialAssignedFlights = requestObj.partialAssignedFlights;
            return flightsRQ;
        }

        /**
         * Adapt Trainings Search Criteria
         * @param requestObj
         * @returns {{}}
         */
        function adaptTrainingsSearchCriteria(requestObj){
            var trainingsRQ = {};
            trainingsRQ.fromDate = requestObj.fromDate;
            if(requestObj.fromDate!==''){
                trainingsRQ.toDate = requestObj.fromDate;
            }
            if (requestObj.location !== '' && typeof requestObj.location != 'undefined') {
              trainingsRQ.location = requestObj.location.trainingLocationCode;
            }
            if (requestObj.category !== '' && typeof requestObj.category != 'undefined') {
              trainingsRQ.trainingCategory = requestObj.category.categoryCode;
            }

            if(requestObj.carriers !== '' && typeof requestObj.carriers != 'undefined' && requestObj.carriers.length > 0) {
              trainingsRQ.carriers = [];
              angular.forEach(requestObj.carriers, function (carrier) {
                trainingsRQ.carriers.push(carrier.code);
              })
            }

            trainingsRQ.nonAssignedOnly = requestObj.nonAssigned;
            trainingsRQ.startPosition = requestObj.startPosition;
            trainingsRQ.pageSize = requestObj.pageSize;
            return trainingsRQ;
        }

        /**
         * Adept Events Search Criteria
         * @param requestObj
         * @returns {*}
         */
        function adaptEventsSearchCriteria(requestObj){
            return requestObj;
        }

        /**
         * adapting the flight response
         * @param responseObj
         * @returns {Array}
         */
        function adaptFlightsResponse(responseObj){
            var toSend = [];
            if (responseObj.hasOwnProperty('flightResponseDTOs') && responseObj.flightResponseDTOs.length > 0){
                toSend = responseObj;
            }
            else{
                MessageService.warning(MessageService.MESSAGES.CREATE_PAIRING.NO_FLIGHTS_FOUND);
            }
            return toSend;
        }

        /**
         * Adept TrainingDTO
         * @param training
         * @returns {TrainingDTO}
         */
        function adaptTrainings(training){
            var tTraining = new TrainingDTO();
            tTraining.slotId = CommonLogicService.getRandomID();
            tTraining.checkInBuffer = training.checkInBuffer;
            tTraining.checkOutBuffer = training.checkOutBuffer;
            tTraining.subProgramCode = getValuesFormObject(training.trainingProgram, 'trainingProgramCode');
            tTraining.subProgramDetail = getValuesFormObject(training.trainingProgramDetail, 'trainingProgDetailDesc');
            tTraining.subProgramDetailId = getValuesFormObject(training.trainingProgramDetail, 'trainingProgramDetailId');
            tTraining.isRestRequired = training.isRestRequired;
            tTraining.trainingLocationID = training.trainingLocId;
            tTraining.trainingProgramId = training.trainingProgramId;
            tTraining.trainingSlot = training.trainingLocCode;
            tTraining.trainingSlotId = training.trainingSlotId;
            tTraining.fromDateStr =((training.fromDateStr===''||training.fromDateStr===undefined)?training.startDateZulu:training.fromDateStr)
            tTraining.fromTimeStr =((training.fromTimeStr===''||training.fromTimeStr===undefined)?training.startTimeZulu:training.fromTimeStr)
            tTraining.toDateStr =((training.toDateStr===''||training.toDateStr===undefined)?training.endDateZulu:training.toDateStr)
            tTraining.toTimeStr =((training.toTimeStr===''||training.toTimeStr===undefined)?training.endTimeZulu:training.toTimeStr)
            return tTraining;
        }

        /**
         *
         * @param obj
         * @param value
         * @returns {*}
         */
        function getValuesFormObject(obj, value, sendNull){
            var send = sendNull?null:"";
            if (obj !== undefined && obj!==null && obj !== {} && obj !== ""){
                send = obj[value];
            }
            return send;
        }

        /**
         * Adept EventDTO
         * @param filterModel
         * @returns {EventDTO}
         */
        function adaptEvents(filterModel){
            var tEvent = new EventDTO();
            tEvent.slotId = CommonLogicService.getRandomID();
            tEvent.eventId = filterModel.selectedEvent.event_id==''?null:filterModel.selectedEvent.event_id;
            tEvent.airCraftType = filterModel.aircraftType.value==''?null:filterModel.aircraftType.value.airCraftType;
            tEvent.startLocation = filterModel.startLocation.value==''?null:filterModel.startLocation.value;
            tEvent.endLocation = filterModel.endLocation.value==''?null:filterModel.endLocation.value;
            tEvent.eventCode = filterModel.selectedEvent.eventCode==''?null:filterModel.selectedEvent.eventCode;
            tEvent.excludeFormPayment = filterModel.excludeFromPayment.value==''?null:filterModel.excludeFromPayment.value;
            tEvent.isAirportStandBy = filterModel.airportStandBy.value==''?null:filterModel.airportStandBy.value;
            tEvent.isOutStationOff = filterModel.outStationOFF.value==''?null:filterModel.outStationOFF.value;
            tEvent.remarks = filterModel.remarks.value==''?null:filterModel.remarks.value;
            tEvent.fromDateStr = filterModel.fromDate.value==''?null:filterModel.fromDate.value;
            tEvent.fromTimeStr =  filterModel.startTime.value==''?null:filterModel.startTime.value;
            tEvent.toDateStr = filterModel.toDate.value==''?null:filterModel.toDate.value;
            tEvent.toTimeStr = filterModel.endTime.value==''?null:filterModel.endTime.value;
            tEvent.eventRelevantFlightLeg = filterModel.eventRelevantFlightLeg.value;
            tEvent.flightNo = filterModel.flightNo;
            return tEvent;
        }

        /**
         * Adept FlightLegDTO
         * @param flight
         * @returns {FlightLegDTO}
         */
        function adaptFlightLegs(flight){
            var tFlight = new FlightLegDTO();
            tFlight.slotId = CommonLogicService.getRandomID();
            tFlight.endLocation = flight.destination;
            tFlight.flightLegId = flight.flightLegId;
            tFlight.flightNo = flight.flightNumber;
            tFlight.modelNo = flight.modelNo;
            tFlight.vipStatus = flight.vipStatus?flight.vipStatus:null;
            tFlight.fromDateStr = flight.estimatedDepartureDate;
            tFlight.fromTimeStr = flight.estimatedDepartureTime;
            tFlight.toDateStr = flight.estimatedArrivalDate;
            tFlight.toTimeStr= flight.estimatedArrivalTime;
            tFlight.plannedFromDateStr = flight.estimatedDepartureDate;
            tFlight.plannedFromTimeStr = flight.estimatedDepartureTime;
            tFlight.plannedEndDateStr  = flight.estimatedArrivalDate;
            tFlight.plannedEndTimeStr  = flight.estimatedArrivalTime;
            tFlight.startLocation = flight.origin;
            return tFlight;
        }

        /**
         * Adept Crew requirement
         * @param filterModel
         * @returns {Array}
         */
        function adaptCrewRequirement(filterModel){
            var sendCrewReq = [];
            var crewReqModel = self.getPairingCrewRequirements();
            angular.forEach(crewReqModel, function(cReq){
                if(filterModel[cReq.crewTypeCode] && !isNaN(parseInt(filterModel[cReq.crewTypeCode],10))){
                    var crewReq = new CrewReqDTO();
                    crewReq.crewTypeCode = cReq.crewTypeCode;
                    crewReq.requiredCrew = parseInt(filterModel[cReq.crewTypeCode],10);
                    if(self.pageMode === self.LOADMODE.EDIT){
                        crewReq.id = cReq.patternCrewReqId;
                        crewReq.version = cReq.version;
                    }
                    sendCrewReq.push(crewReq);
                }
            });
            return sendCrewReq;
        }

      function adaptCrewRequirementSaveDTO(filterModel, crewMaleReq, crewFemaleReq, crewAugmentedReq){
        var sendCrewReq = [];
        var crewReqModel = self.getPairingCrewRequirements();

        for(var key in filterModel ) {
          if (filterModel.hasOwnProperty(key)) {
            var crewReq = new CrewReqDTO();

            if(isNaN(parseInt(filterModel[key],10))){
              continue;
            }

            crewReq.crewTypeCode = key;
            crewReq.requiredCrew = parseInt(filterModel[key],10);

            for(var i = 0; i < crewReqModel.length; i++ ){
              var cReq = crewReqModel[i];

              if(filterModel[key] && !isNaN(parseInt(filterModel[key],10)) && key === cReq.crewTypeCode){

                if(self.pageMode === self.LOADMODE.EDIT){
                  crewReq.id = cReq.patternCrewReqId;
                  crewReq.version = cReq.version;
                }
                break;
              }
            }

            sendCrewReq.push(crewReq);
          }
        }

        for(var key in crewMaleReq){

          var crewReq = "";
          var maleCount = parseInt(crewMaleReq[key],0)
          for (var i in sendCrewReq){
            if(sendCrewReq[i].crewTypeCode === key){
              crewReq = sendCrewReq[i];
              crewReq.minimumMaleReq = maleCount;
              break;
            }
          }

          if(crewReq === "" && maleCount > 0){
            var crewReq = new CrewReqDTO();
            crewReq.crewTypeCode = key;
            crewReq.minimumMaleReq = maleCount;
            sendCrewReq.push(crewReq);
          }

        }

        for(var key in crewFemaleReq){

          var crewReq = "";
          var femaleCrewCount = parseInt(crewFemaleReq[key],0);
          for (var i in sendCrewReq){
            if(sendCrewReq[i].crewTypeCode === key){
              crewReq = sendCrewReq[i];
              crewReq.minimumFemaleReq = femaleCrewCount;
              break;
            }
          }

          if(crewReq === "" && femaleCrewCount > 0){
            var crewReq = new CrewReqDTO();
            crewReq.crewTypeCode = key;
            crewReq.minimumFemaleReq = femaleCrewCount;
            sendCrewReq.push(crewReq);
          }

        }

        for(var key in crewAugmentedReq){

          var crewReq = "";
          var augmentedCount = parseInt(crewAugmentedReq[key],0);
          for (var i in sendCrewReq){
            if(sendCrewReq[i].crewTypeCode === key){
              crewReq = sendCrewReq[i];
              crewReq.augmentedCrew = augmentedCount;
              break;
            }
          }

          if(crewReq === "" && augmentedCount > 0){
            var crewReq = new CrewReqDTO();
            crewReq.crewTypeCode = key;
            crewReq.augmentedCrew = augmentedCount;
            sendCrewReq.push(crewReq);
          }

        }

        return sendCrewReq;
      }


        function checkMasterCrewTypeInCrewRequirements(crewModel, masterCrewType){
            var availCrewType = adaptCrewRequirement(crewModel), send=false;
            for (var key in availCrewType) {
               if(getMasterCrewTypeByCrewType(availCrewType[key].crewTypeCode) === masterCrewType){
                   send = true;
                   break;
               }
            }
            return send;
        }

        function getMasterCrewTypeByCrewType(crewType){
            var crewList = CommonMasterData.getCrewTypes(), send=null;
            for (var i=0;i< crewList.length;i++) {
                if(crewList[i].crewTypeCode === crewType){
                    send = crewList[i].crewTypeMasterCode;
                    break;
                }
            }
            return send;
        }

        /**
         * LANGUAGE
         * @param languageReq
         * @returns {Array}
         */
        function adeptLanguageReq(languageReq){
            var las = [];
            var langList = self.getPairingLanguageCrew();
            angular.forEach(langList, function(langData){
              if(!isNaN(parseInt(languageReq[langData.langCode],10)) &&
                languageReq[langData.langCode] >= 0){
                var lang = new LanguageRequirementViewDTO(self.pageMode);
                lang.langCode = langData.langCode;
                if(languageReq[langData.langCode] != null) {
                  lang.minReqCrew = parseInt(languageReq[langData.langCode], 10);
                  lang.noOfCrew = parseInt(languageReq[langData.langCode], 10);
                }else{
                  lang.minReqCrew = null;
                  lang.noOfCrew = null;
                }
                if(self.pageMode===self.LOADMODE.EDIT){
                  lang.id = langData.id;
                  lang.version = langData.version;
                }
                if ((self.model.isMandatory[langData.langCode] === true) || (self.model.isMandatory[langData.langCode] === 'Y')){
                  lang.isMandatory = 'Y';
                }else{
                  lang.isMandatory = 'N';
                }

                las.push(lang);
              }
            });
            return las
        }

      function adeptGenderReq(req){

        var genderRequirementDto = new GenderRequirementViewDTO(self.pageMode);

        genderRequirementDto.noOfFemaleCrew = req.noOfRequiredFemale;
        genderRequirementDto.noOfMaleCrew = req.noOfRequiredMale;

        if(self.pageMode===self.LOADMODE.EDIT){
          genderRequirementDto.id = req.id;
          genderRequirementDto.version = req.version;
        }

        return genderRequirementDto;

      }
         self.adeptMinimumRestToMin = function(minimumRest) {
         var tt=minimumRest.split(":");
          var min = tt[0]*60+tt[1]*1;
          return min;
        }

        /**
         * set the loaded pairing languages to the model
         * @param languageList
         */
        function setLoadedPairingLanguage(languageList){
            var las = [];
            angular.forEach(languageList, function(langData){
                var lang = new LanguageRequirementViewDTO(self.pageMode);
                lang.langCode = langData.languageCode;
                lang.minReqCrew = langData.requiredCrew;
                lang.noOfCrew = langData.assignedCrew;
                if(self.pageMode===self.LOADMODE.EDIT){
                    lang.id = langData.patternLangReqId;
                    lang.version = langData.version;
                }
                las.push(lang);
            });
            self.setPairingLanguageCrew(las);
        }

        function init() {
        	RemoteService.searchTrackingColors("aircraftModel").then(
					function (response) {
						if(response.success){
							self.blockColorsForFlight = response.colors;
						}
					},
					function (error) {
						MessageService.error(error.msg[0]);
					});
        	RemoteService.getBaseAirport().then(
					function (response) {
						if(response.success){
							self.model.airlineBase = response;
						}
					},
					function (error) {
						MessageService.error(error.msg[0]);
					});
        	RemoteService.searchTrackingColors("event").then(
					function (response) {
						if(response.success){
							self.blockColorsForEvent = response.colors;
						}
					},
					function (error) {
						MessageService.error(error.msg[0]);
					});
        	RemoteService.searchTrackingColors("training").then(
        			function (response) {
        				if(response.success){
        					self.blockColorsForTraining = response.colors;
        				}
        			},
        			function (error) {
        				MessageService.error(error.msg[0]);
        			});
          RemoteService.searchTrackingColors("other").then(
            function (response) {
              if(response.success){
                self.trackingColorsOthers = response.colors;
              }
            },
            function (error) {
              MessageService.error(error.msg[0]);
            });
        }

        init();

    }
}());
